"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Spinner = () => {
    return (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {});
};
exports.Spinner = Spinner;
//# sourceMappingURL=index.js.map